<div class="mb-25">
  <div>
    <mat-checkbox [formControl]="showLifecycleCtrl">
      <label>Prikaži tijek svih projekata</label>
    </mat-checkbox>
  </div>
</div>

<div class="projects-container">
  @for (project of filteredProjects; track project) {
    <div class="col-lg-4 col-md-6 project-card">
      <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-header>
          <h5>{{ project.organizationName }}</h5>
        </mat-card-header>
        <mat-card-content class="d-flex">
          <!-- Left column: Project data (80% on desktop, full width on mobile) -->
          <div class="project-data-column">
            <p>
              <strong>Vrsta projekta:</strong>
              {{ project.type === ProjectType.Allocation ? 'Izravna dodjela sredstava' : 'Prijava na natječaj' }}
            </p>
            <p>
              <strong>Natječaj:</strong> {{ project.grantName }}
            </p>
            <p>
              <strong>Naziv programa/projekta:</strong> {{ project.name }}
            </p>
            <p>
              <strong>Odobreni iznos:</strong> {{ project.approvedAmount | currency:'EUR' }}
            </p>
            <p>
              <strong>Godina projekta:</strong> {{ project.year }}
            </p>
            <p>
              <strong>Datum projekta:</strong> {{ project.createdAt | date: 'd.M.yyyy. HH:mm:ss' }}
            </p>
            <p>
              <strong>Početak provedbe:</strong> {{ project.startedAt | date: 'd.M.yyyy. HH:mm:ss' }}
            </p>
            <p>
              <strong>Završetak provedbe:</strong> {{ project.completedAt | date: 'd.M.yyyy. HH:mm:ss' }}
            </p>
            <p>
              <strong>Status:</strong>
              <span class="daxa-badge"
                          [ngClass]="{
                        'blue': project.status === ProjectStatus.Preparation,
                        'yellow': project.status === ProjectStatus.Started,
                        'green': project.status === ProjectStatus.Completed
                      }">
                {{ project.userFriendlyStatus }}
              </span>
            </p>
          </div>
          <!-- Status badges in collapsible panel for mobile-friendly display -->
          <div class="status-badges-column">
            <mat-expansion-panel class="lifecycle-panel" [expanded]="showLifecycleCtrl.value">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <span>Tijek projekta</span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="d-flex flex-column">
                <span class="daxa-badge text-center status-badge"
                  [ngClass]="{ green: project.isInitialBudgetInSync, red: !project.isInitialBudgetInSync }">
                  {{ project.isInitialBudgetInSync ? 'Proračun usklađen' : 'Proračun nije usklađen' }}
                </span>
                <span class="daxa-badge text-center status-badge"
                  [ngClass]="{ green: project.isInitialBudgetApproved, red: !project.isInitialBudgetApproved }">
                  {{ project.isInitialBudgetApproved ? 'Proračun odobren' : 'Proračun nije odobren' }}
                </span>
                <span class="daxa-badge text-center gray status-badge">
                  {{ project.hasReallocations ? 'Ima prenamjenu' : 'Nema prenamjenu' }}
                </span>
                @if (project.hasReallocations) {
                  <span class="daxa-badge text-center status-badge"
                    [ngClass]="{ green: project.areReallocationBudgetsInSync, red: !project.areReallocationBudgetsInSync }">
                    {{ project.areReallocationBudgetsInSync ? 'Prenamjena usklađena' : 'Prenamjena nije usklađena' }}
                  </span>
                }
                @if (project.hasReallocations) {
                  <span class="daxa-badge text-center status-badge"
                    [ngClass]="{ green: project.areReallocationBudgetsApproved, red: !project.areReallocationBudgetsApproved }">
                    {{ project.areReallocationBudgetsApproved ? 'Prenamjena odobrene' : 'Prenamjena nije odobrena' }}
                  </span>
                }
                <span class="daxa-badge text-center status-badge"
                  [ngClass]="{ green: project.contractCreated, red: !project.contractCreated }">
                  {{ project.contractCreated ? 'Ugovor kreiran' : 'Ugovor nije kreiran' }}
                </span>
                <span class="daxa-badge text-center status-badge"
                  [ngClass]="{ green: project.reportsApproved, red: !project.reportsApproved }">
                  {{ project.reportsApproved ? 'Izvještaji odobreni' : 'Izvještaji nisu odobreni' }}
                </span>
                @if (project.status === ProjectStatus.Completed) {
                  <span class="daxa-badge text-center gray status-badge">
                    {{ project.hasRefundItems ? 'Ima stavke povrata' : 'Nema stavki povrata' }}
                  </span>
                }
                @if (project.status === ProjectStatus.Completed) {
                  <span class="daxa-badge text-center gray status-badge">
                    {{ project.refundCreated ? 'Odluka o povratu kreirana' : 'Nema Odluku o povratu' }}
                  </span>
                }
              </div>
            </mat-expansion-panel>
          </div>
        </mat-card-content>
        <mat-card-actions>
          <button mat-icon-button color="primary" matTooltip="Projektni proračuni" (click)="goToProjectBudgets(project)">
            <mat-icon>money</mat-icon>
          </button>
          @if (project.isActionAllowed('ViewReports')) {
            <button mat-icon-button color="primary" matTooltip="Projektni izvještaji" (click)="goToProjectReports(project)">
              <mat-icon>bar_chart</mat-icon>
            </button>
          }
          <button mat-icon-button color="primary" matTooltip="Projektni saldo" (click)="goToProjectSaldo(project)">
            <mat-icon>balance</mat-icon>
          </button>
          @if (project.isActionAllowed('ViewRefunds')) {
            <button mat-icon-button  color="primary" matTooltip="Pregledaj Odluke o povratu" (click)="goToViewRefunds(project)">
              <mat-icon>undo</mat-icon>
            </button>
          }
        </mat-card-actions>
      </mat-card>
    </div>
  }
</div>
